module.exports = __webpack_public_path__ + "img/Rectangle 682.e1e736d7.png";